var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-container"},[(_vm.titleFlag)?_c('div',{staticClass:"title"},[_vm._v("全部出价")]):_vm._e(),_c('Table',{attrs:{"tableData":_vm.dataTable,"option":_vm.option}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }